// @flow
import { Context, createContext } from 'react'

/**
 * React Context object, contains the current locale, used for setting the
 * correct language throughout the app.
 * @type {{$$typeof, _calculateChangedBits, _currentValue, _currentValue2,
 *   Provider, Consumer}}
 */
// TODO find a way to read from the URL
export const LocaleContext: Context<string> = createContext('de')
